/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Maybe } from '@irian-ro/util-functions';
import { PackageStatusType } from './package-status-type';
import { PackageStateModel } from './package.state.model';

export class PackageDtoModel extends JSONable {
  uuid: Maybe<string> | undefined = undefined;

  owner: Maybe<string> | undefined = undefined;

  id: Maybe<string> | undefined = undefined;

  shipmentBaseUuid: Maybe<string> | undefined = undefined;

  height: Maybe<number> | undefined = undefined;

  width: Maybe<number> | undefined = undefined;

  length: Maybe<number> | undefined = undefined;

  weight: Maybe<number> | undefined = undefined;

  pieces: Maybe<number> | undefined = undefined;

  type: Maybe<string> | undefined = undefined;

  tags: string[] = [];

  version: Maybe<number> | undefined = undefined;

  standardPackageDimensionUuid: Maybe<string> | undefined = undefined;

  standardPackageDimensionName: Maybe<string> | undefined = undefined;

  groupId: Maybe<string> | undefined = undefined;

  currentPackageStatusType: Maybe<PackageStatusType> | undefined = undefined;

  state: PackageStateModel | undefined = undefined;

  static createForm(): FormGroup {
    return new FormGroup({
      uuid: new FormControl(null),
      shipmentBaseUuid: new FormControl(null),
      pieces: new FormControl(1, Validators.required),
      id: new FormControl(null),
      height: new FormControl(null, Validators.required),
      width: new FormControl(null, Validators.required),
      length: new FormControl(null, Validators.required),
      weight: new FormControl(null, Validators.required),
      type: new FormControl(null),
      tags: new FormControl([]),
      standardPackageDimensionUuid: new FormControl(null),
      standardPackageDimensionName: new FormControl(null),
    });
  }
}
